import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostPreviewSucceed, EGetPostPreviewActionType } from './types';
import { IPostPreview } from '../../../types/postPreview';

export const getPostPreviewSucceed: (data: IPostPreview) => TGetPostPreviewSucceed = actionGenerator<
  EGetPostPreviewActionType.Succeed,
  IPostPreview
>(EGetPostPreviewActionType.Succeed);
